module.exports = __webpack_public_path__ + "media/images/haircut/card-mobile@3x-a785fd31c1fb91d77cff2862d46a2fc4.jpg";